
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div>
    <GeneralInformations
      :ficheValidator="ficheValidator"
      :applicationSectors="applicationSectors"
      :simulationStatus="simulationStatus"
      :isVIEWER="isVIEWER"
      :contractingDate="contractingDate"
      :deliveryDate="deliveryDate"
      @setPeriod="$emit('setPeriod', ficheValidator)"
      @workTypeBySector="$emit('workTypeBySector', ficheValidator)"
      @fetchFiches="$emit('fetchFiches', ficheValidator)"
      @getFormConditions="$emit('getFormConditions', ficheValidator)"
    ></GeneralInformations>

    <div v-if="ficheValidator.ficheNumber.$model">
      <precatity
        v-if="ficheValidator.fiche.$model.precarite"
        :isVIEWER="isVIEWER"
        :tabsFicheValidation="tabsFicheValidation"
        :tabFiche="ficheValidator"
        :periods="periods"
        :departments="departments"
        @fetchPrecarity="$emit('fetchPrecarity', ficheValidator)"
      >
      </precatity>

      <fiche-conditions
        :conditions="ficheValidator.conditions"
        :isVIEWER="isVIEWER"
        :calculFormula="ficheValidator.calculFormula"
        :ficheIndex="
          addressFicheIndex.addressIndex +
          '-' +
          addressFicheIndex.addressFicheIndexIndex
        "
        :climateZone="addressFicheIndex.climateZone"
        @checkConditions="$emit('checkConditions', ficheValidator)"
      ></fiche-conditions>
    </div>
  </div>
</template>

<script>
import FicheConditions from "./FicheCondition";
import Precatity from "./Precatity";
import GeneralInformations from "./GeneralInformations";
export default {
  name: "Fiche",
  components: { GeneralInformations, Precatity, FicheConditions },
  props: [
    "ficheValidator",
    "tabsFicheValidation",
    "applicationSectors",
    "departments",
    "periods",
    "addressFicheIndex",
    "simulationStatus",
    "isVIEWER",
    "contractingDate",
    "deliveryDate"
  ],
};
</script>

<style scoped>
</style>
